<template>
  <div class="head_menu">
    <ul>
      <li v-if="loginUserInfo.inquiry_disp_fg">
        <a href="#" @click.prevent="inquiryHandler">お問合せ</a>
      </li>
      <li>
        <a href="#" @click.prevent="showPrivacy">個人情報について</a>
      </li>
      <li><a href="#" @click.prevent="logoutHandler">ログアウト</a></li>
    </ul>
    <p>
      <span v-if="loginUserInfo.client_na">{{ loginUserInfo.client_na }}</span>
      <span v-if="loginUserInfo.clientsub_na">{{
        loginUserInfo.clientsub_na
      }}</span>
      <span v-if="loginUserInfo.comuser_fg && loginUserInfo.comuid_na">
        {{ loginUserInfo.comuid_na }}
      </span>
      <span v-if="!loginUserInfo.comuser_fg && loginUserInfo.loginuser_na"
        >{{ loginUserInfo.loginuser_na }}
      </span>
      <span>様</span>
    </p>
  </div>
</template>

<script>
import { store as loginUserStore } from "../store/LoginUser";
import { mutations as BootstrapMutations } from "../store/Bootstrap";

export default {
  computed: {
    loginUserInfo() {
      return loginUserStore.info;
    }
  },
  methods: {
    inquiryHandler() {
      this.submitNewTabAsteria(
        "Inquiry",
        "loadHTML_forInquiry",
        {},
        "",
        "/inquiry/inquiry.html"
      );
    },

    showPrivacy() {
      BootstrapMutations.showPrivacy();
    },

    async logoutHandler() {
      const beforeHook = this.getHookBeforeSubmitAsteria();
      if (beforeHook !== null) {
        if (!beforeHook()) {
          return;
        }
      }

      const response = await this.postAsteria("Login", "logout");

      if (response.responseData.return != 0) {
        if (response.responseData.return != 9) {
          window.alert("ログアウトに失敗しました");
        }
        return;
      }

      // this.submitAsteria("", "", {}, "", "/");
      this.linkToLogin();
    }
  }
};
</script>
